export const PREFERENCE_PANEL = {
    PHOTO: 'photo',
    INFORMATIONS: 'informations',
    SECURITY: 'security',
    DISABLE_ACCOUNT: 'disable-account'
};